<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'

const PROMOTION_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
}
const DEFAULT_CAMPAIGN_DATA = {
  variationId: 0,
  decisionId: '',
}

export default {
  name: 'HomeDyReporter',

  data() {
    return {
      primaryCtas: [],
      secondaryCtas: {
        left: [],
        right: [],
      },
      maxPrimarySlideIndex: -1,
    }
  },

  mounted() {
    this.populateCtaSettings()
    this.addClickListeners()
  },

  methods: {
    ...mapActions({
      reportEngagementToDy: 'dynamicYield/reportEngagementToDy',
      reportEventsToDy: 'dynamicYield/reportEventsToDy',
    }),

    getDyHashFromElement(element) {
      return element?.closest('[data-dy-hash]')?.dataset.dyHash.split('__')
    },

    isPrimaryPromotion(ctaSettings) {
      return ctaSettings.type === PROMOTION_TYPES.primary
    },

    populateCtaSettings() {
      const primaryElement = document.querySelector('.js-home-primary-promotion')
      const secondaryElements = document.querySelectorAll('.js-home-secondary-promotion')

      if (primaryElement) {
        const dyHash = this.getDyHashFromElement(primaryElement)

        primaryElement.querySelectorAll('.js-hero-ctr').forEach(cta => {
          const slideIndex = Number(cta.closest('[data-slick-index]').dataset.slickIndex)
          this.maxPrimarySlideIndex = Math.max(this.maxPrimarySlideIndex, slideIndex)
          this.primaryCtas.push({
            type: PROMOTION_TYPES.primary,
            element: cta,
            slideIndex,
            campaignData: this.getCampaignData(dyHash),
          })
        })
        this.fixSlideIndexOfClones()
      }
      secondaryElements.forEach((secondaryElement, index) => {
        const side = Object.keys(this.secondaryCtas)[index]
        const dyHash = this.getDyHashFromElement(secondaryElement)

        secondaryElement.querySelectorAll('.js-hero-ctr').forEach(cta => {
          this.secondaryCtas[side].push({
            type: PROMOTION_TYPES.secondary,
            element: cta,
            campaignData: this.getCampaignData(dyHash),
          })
        })
      })
    },

    fixSlideIndexOfClones() {
      // The primary carousel is built with Slick https://kenwheeler.github.io/slick/
      // which has a clone of the first and last slides that are used to enable an infinite loop
      // (making sure you can slide from the last slide to the first one and vice versa).
      // Those clones don't have the correct slide index set in data-slick-index attribute.
      this.primaryCtas.forEach(ctaSettings => {
        if (ctaSettings.slideIndex === -1) ctaSettings.slideIndex = this.maxPrimarySlideIndex - 1
        if (ctaSettings.slideIndex === this.maxPrimarySlideIndex) ctaSettings.slideIndex = 0
      })
    },

    getCampaignData(dyHash) {
      if (dyHash && dyHash.length > 1) {
        return {
          variationId: Number(dyHash[0]),
          decisionId: dyHash[1],
        }
      } else {
        return { ...DEFAULT_CAMPAIGN_DATA }
      }
    },

    addClickListeners() {
      this.primaryCtas.forEach(cta => this.addClickListener(cta))
      for (const side in this.secondaryCtas) {
        this.secondaryCtas[side].forEach(cta => this.addClickListener(cta))
      }
    },

    addClickListener(ctaSettings) {
      if (!ctaSettings.campaignData?.decisionId || ctaSettings.element.hasDyClickEvent) {
        return
      }
      const eventProps = { type: ctaSettings.type }
      if (this.isPrimaryPromotion(ctaSettings)) eventProps.position = ctaSettings.slideIndex + 1

      ctaSettings.element.addEventListener('click', () => {
        this.reportEngagementToDy(ctaSettings.campaignData)
        this.reportEventsToDy([{ name: 'Homepage CTA click', properties: eventProps }])
      })
      ctaSettings.element.hasDyClickEvent = true
    },
  },
}
</script>
